export default "__VITE_PUBLIC_ASSET__b129c13b__"